import React from 'react';
import { Backdrop } from '@/components/backdrop';
import ErrorComponent from '@/components/error';
import { useRouteError } from 'react-router';

const ErrorPage = (): React.JSX.Element => {
  const error = useRouteError();
  console.error(error);
  return (
    <div className="authentication">
      <div className="authentication-form">
        <ErrorComponent />
      </div>
      <Backdrop />
    </div>
  );
};

export default ErrorPage;
